(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["add-to-cart"] && !Shopify.designMode) return;
  try {
    (function () {
    function formatPrice(cents, withCurrency) {
      var amount = (Number(cents) || 0) / 100;
      var text = '$' + amount.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return withCurrency ? text + ' MXN' : text;
    }

    function replaceInTextNodes(root, oldText, newText) {
      if (!oldText || oldText === newText) return;
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue.indexOf(oldText) !== -1) {
          node.nodeValue = node.nodeValue.split(oldText).join(newText);
        }
      }
    }

    document.addEventListener('variant:update', function (event) {
      var detail = event.detail || {};
      var variant = detail.resource;
      if (!variant || variant.price === undefined) return;

      var wrappers = document.querySelectorAll('[data-atc-price][data-atc-price-enabled="true"]');
      wrappers.forEach(function (wrapper) {
        var withCurrency = wrapper.getAttribute('data-atc-price-currency') === 'true';
        var oldText = wrapper.getAttribute('data-atc-price-current');
        var newText = formatPrice(variant.price, withCurrency);

        replaceInTextNodes(wrapper, oldText, newText);
        wrapper.setAttribute('data-atc-price-current', newText);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["agregado-rapido"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__quickAddReady) return;
    window.__quickAddReady = true;

    var toastEl = null;
    var toastTimer = null;

    function showToast(message) {
      if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.className = 'qa__toast';
        toastEl.setAttribute('role', 'status');
        document.body.appendChild(toastEl);
      }
      toastEl.innerHTML = message;
      toastEl.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toastEl.classList.remove('is-visible');
      }, 2600);
    }

    function updateCartCount(cart) {
      var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
      if (count === null) return;

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'quick-add',
          data: { source: 'quick-add', itemCount: count }
        }
      }));

      document.querySelectorAll('[data-cart-count], .cart-count, .cart-bubble__text-count').forEach(function (el) {
        el.textContent = count;
      });
    }

    function openCartDrawer() {
      var drawer = document.querySelector('cart-drawer-component, cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }
      if (drawer && typeof drawer.showDialog === 'function') {
        drawer.showDialog();
        return true;
      }
      return false;
    }

    function addToCart(button) {
      var wrapper = button.closest('[data-qa]');
      if (!wrapper || button.disabled || button.classList.contains('is-loading')) return;

      var variantId = button.getAttribute('data-variant-id');
      var after = wrapper.getAttribute('data-qa-after');
      var successText = wrapper.getAttribute('data-qa-success-text') || 'Agregado';
      var errorText = wrapper.getAttribute('data-qa-error-text') || 'No se pudo agregar';
      var status = wrapper.querySelector('[data-qa-status]');
      var mainButton = wrapper.querySelector('.qa__button');

      button.classList.add('is-loading');

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw data;
            return data;
          });
        })
        .then(function () {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          button.classList.remove('is-loading');
          button.classList.add('is-success');
          if (mainButton && mainButton !== button) mainButton.classList.add('is-success');
          if (status) status.textContent = successText;

          updateCartCount(cart);

          if (after === 'cart_page') {
            window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
            return;
          }

          if (after === 'drawer' && openCartDrawer()) {
            // Carrito lateral abierto
          } else {
            showToast('✓ ' + successText + ' · <a href="/cart">Ver carrito</a>');
          }

          setTimeout(function () {
            button.classList.remove('is-success');
            if (mainButton) mainButton.classList.remove('is-success');
            var panel = wrapper.querySelector('[data-qa-panel]');
            if (panel) closePanel(wrapper);
          }, 1600);
        })
        .catch(function (error) {
          button.classList.remove('is-loading');
          var message = (error && (error.description || error.message)) || errorText;
          if (status) status.textContent = message;
          showToast(message);
        });
    }

    function openPanel(wrapper) {
      var panel = wrapper.querySelector('[data-qa-panel]');
      var opener = wrapper.querySelector('[data-qa-open]');
      if (!panel) return;
      panel.hidden = false;
      if (opener) opener.setAttribute('aria-expanded', 'true');
      var firstOption = panel.querySelector('.qa__variant:not([disabled])');
      if (firstOption) firstOption.focus({ preventScroll: true });
    }

    function closePanel(wrapper) {
      var panel = wrapper.querySelector('[data-qa-panel]');
      var opener = wrapper.querySelector('[data-qa-open]');
      if (!panel) return;
      panel.hidden = true;
      if (opener) opener.setAttribute('aria-expanded', 'false');
    }

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var addButton = target.closest('[data-qa-add]');
      var openButton = target.closest('[data-qa-open]');
      var closeButton = target.closest('[data-qa-close]');
      var insideQa = target.closest('[data-qa]');

      if (addButton || openButton || closeButton || insideQa) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (addButton) {
        addToCart(addButton);
      } else if (openButton) {
        var wrapper = openButton.closest('[data-qa]');
        var panel = wrapper && wrapper.querySelector('[data-qa-panel]');
        if (panel && panel.hidden) openPanel(wrapper);
        else if (wrapper) closePanel(wrapper);
      } else if (closeButton) {
        closePanel(closeButton.closest('[data-qa]'));
      } else if (!insideQa) {
        document.querySelectorAll('[data-qa-panel]:not([hidden])').forEach(function (panel) {
          closePanel(panel.closest('[data-qa]'));
        });
      }
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-qa-panel]:not([hidden])').forEach(function (panel) {
        closePanel(panel.closest('[data-qa]'));
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
